import React from "react";
import './explore.css';
import fotoa from '../images/explore/rapeles_salto/rappelb.jpg'
//import fotob from '../images/explore/akopan/P1090863a.JPG'
import fotoc from '../images/explore/kukenan/RLC_8269a.JPG'
//import fotod from '../images/explore/fluvial/RLC_9391a.JPG'
//import fotoe from '../images/explore/merida/Pico_El_Leon-a.jpg'
import fotof from '../images/explore/roraima/RLC_4032a.JPG'

const Explore = () => {
  return(
    <div className="bg-white">
      
        <main className="h-100 d-md-inline-block">
          <div className="heroExplore h-100 text-light d-md-inline-block">
            <h1>Go places</h1>
            <p>... explore!</p>
            <img alt="" src={require('../images/explore/DSC_0091a.JPG')} />
          </div>
        </main>

        <div className="text-dark col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 m-0 fontResponsive">
          <div className="">
            <h2 className="card-title text-center">High Performance Expeditions</h2>
            <h5 className="card-title text-left">
            We are adventurers. Tirika Expeditions was born from our yearn for deeply moving experiences and our reverence for the natural world. We provide bold trips for fearless wanderers into the unspoiled landscapes of Venezuela.
            <br/><br/>
            Join us as we take you to the heart of Arthur Conan Doyle’s Lost World, a region as breathtaking as it is mysterious. Marvel at the shooting stars from snow-capped peaks of the northern Andes, or wake up to the mesmerizing sunrise in the lush southern savannas. Lose yourself in the mystifying rock formations of Precambrian table mountains, and navigate through tea-colored rivers flanked by dense walls of tropical diversity. Breathe in the gentle spray of the worlds tallest waterfall as you dangle from a tiny rope over vast canopies of rain forest. 
            <br/><br/>
            We design unforgettable adventures, trips as exciting as they are inspiring, journeys meant to change your soul.</h5>
          </div>
        </div>

        <div className="row m-0 p-0 justify-content-around">
          
          <div className="border-0 text-light col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
          <a href="/angel_falls_abseil" className="">
            <img className="img-fluid card-img rounded" src={fotoa} alt=""/>
            <div className="text-light card-img-overlay subheroExplore-a p-2 m-2">
              <h5 className="card-title">Angel Falls abseil</h5>
              <p className="card-text">Feel the void!! Descend more than 3,000 feet just beside the highest waterfall on the planet</p>
            </div>
          </a>
          </div>

          <div className="border-0 text-light col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
            <a href="/kukenan_trek" className="">         
            <img className="img-fluid card-img rounded" src={fotoc} alt=""/>
            <div className="text-light card-img-overlay subheroExplore-c">
              <h5 className="card-title">Kukenán Tepuy Trek</h5>
              <p className="card-text">Venezuela's most mystic flattop mountain</p>
            </div>
            </a>
          </div>

          <div className="border-0 text-light col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
            <a href="/roraima_prow_trek" className="">
            <img className="img-fluid card-img" src={fotof} alt="" />
            <div className="text-light card-img-overlay subheroExplore-f">
              <h5 className="card-title">Roraima Trek to North Prow</h5>
              <p className="card-text">Go through Venezuela, Brazil and Guyana by crossing Mount Roraima from south to north</p>
            </div>
            </a>
          </div>

          {/*<div className="text-dark col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2 m-0" style={{fontFamily: 'Expletus Sans'}}>
            <div className="">
            </div>
          </div>*/}
          

          {/*<div className="border-0 text-dark col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
            <a href="/fluvial_kavac_canaima" className="">
            <img className="img-fluid card-img rounded" src={fotod} alt=""/>
            <div className="text-dark card-img-overlay subheroExplore-d">
              <h5 className="card-title">Kavac - Canaima Boat Trip</h5>
              <p className="card-text">Visit Angel Falls going down Churun river</p>
            </div>
            </a>
          </div>*/}

          {/*<div className="border-0 text-light col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
            <a href="/andes" className="">
            <img className="img-fluid card-img rounded" src={fotoe} alt=""/>
            <div className="text-light card-img-overlay subheroExplore-e">
              <h5 className="card-title">Venezuelan Andes</h5>
              <p className="card-text">Where The Andes begin</p>
            </div>
            </a>
          </div>*/}

          {/*<div className="border-0 text-light col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
            <a href="/akopan_trek" className="">
            <img className="img-fluid card-img rounded" src={fotob} alt=""/>
            <div className="text-light card-img-overlay subheroExplore-b">
              <h5 className="card-title">Akopan Tepuy Trek</h5>
              <p className="card-text">Trip to the remote Tirika Valley</p>
            </div>
            </a>
          </div>*/}
          
        </div>
      
    </div>
  );
};

export default Explore;



// WEBPACK FOOTER //
// ./src/components/explore.jsx